import mapValues from 'lodash/mapValues';

/**
 * Deep-copies the given value or structure, as fast as possible.
 * Note that only structures with JSON-serializable values are supported!
 * For structures containing with special values, use e.g. Lodash `cloneDeep`.
 * @param value value or structure to clone
 * @returns the deep-cloned value or structure
 */
export default function deepClone<Value>(value: Value, depth?: number | null): Value {
  if (typeof value === 'object' && value != null) {
    // Value is either an object or an array structure.
    if (depth == null || !Number.isFinite(depth)) {
      // Deep-clone with JSON-serialization + deserialization
      return JSON.parse(JSON.stringify(value));
    }
    if (depth <= 0) {
      // No deep-cloning at this level
      return value;
    }
    if (Array.isArray(value)) {
      // Recursively clone an array
      return value.map((item) => deepClone(item, depth - 1)) as Value;
    }
    // Recursively clone an object
    return mapValues(value, (prop) => deepClone(prop, depth - 1)) as Value;
  }
  // Value is an immutable primitive, so it can be returned as-is
  return value;
}
